import React, {useRef, useState} from "react";
import styled from "styled-components";
import Button from "@components/common/Button";
import {ModalBody} from "./Modal";
import {useStore} from "../../app/store";

const CommonBoardPreviewModal = ({id, handleCloseModal, modalDepth}) => {
    const [currentTabView, setCurrentTabView] = useState('pc');
    const {appEditorStore, modalStore, confirmStore} = useStore();
    const commonPreviewIframe = useRef(null);


    const clickClose = () => {
        handleCloseModal(modalDepth);
    }


    // useEffect(() => {
    //     const messageHandler = function (e) {
    //         const {id, height} = e.data;
    //         const iframe = document.getElementById(id);
    //         iframe.style.height = height + 'px';
    //     };
    //     window.addEventListener('message', messageHandler)
    //     return () => {
    //         window.removeEventListener('message', messageHandler);
    //     }
    // }, []);
    // const resizeIframe = (iframe, width) => {
    //     if (iframe && width) {
    //         iframe.style.width = `${width}px`;
    //         const prevSrc = iframe.src;
    //         iframe.src = '';
    //         iframe.src = prevSrc;
    //     }
    //
    //     // console.log(iframe)
    //
    //
    //     // iframe.contentWindow.postMessage({id: 'change-device'}, '*');
    //     // window.addEventListener('message', (e) => {
    //     //     const {id, height} = e.data;
    //     //     if (e.data.id === 'change-device') {
    //     //         const height = document.body.scrollHeight;
    //     //         window.parent.postMessage({id: e.source.frameElement.id, height}, '*');
    //     //     }
    //     // });
    //     // iframe.contentWindow.addEventListener('message', (e) => {
    //     //     const {id, height} = e.data;
    //     //     // const iframe = iframe.document.getElementById(id);
    //     //     // if (height === 0) {
    //     //     //     const prevSrc = iframe.children[0].getAttribute('src');
    //     //     //     iframe.children[0].setAttribute('src', '');
    //     //     //     iframe.children[0].setAttribute('src', prevSrc);
    //     //     // } else {
    //     //     //     iframe.style.height = height + 'px';
    //     //     // }
    //     //
    //     // })
    //     // if (iframe && width) {
    //     //     iframe.style.width = `${width}px`;
    //     // }
    //     // const iframeDocument = iframe.contentDocument;
    //     // if (!iframeDocument) return;
    //     // const contentHeight = iframeDocument.documentElement.getBoundingClientRect().height;
    //     // if (iframe) {
    //     //     iframe.style.height = `${contentHeight}px`;
    //     // }
    // };
    const pcView = () => {
        setCurrentTabView('pc');
        const iframe = document.getElementById(`common-${appEditorStore.commonBoardEditorModal.data._id}`);
        iframe.style.height = appEditorStore.commonBoardEditorModal.ratio.Desktop.height + 'px';
        // resizeIframe(iframe, 775);
    }
    const moView = () => {
        setCurrentTabView('mo');
        const iframe = document.getElementById(`common-${appEditorStore.commonBoardEditorModal.data._id}`);
        iframe.style.height = appEditorStore.commonBoardEditorModal.ratio.Mobile.height + 'px';
        // resizeIframe(iframe, 400);
    }
    const currentEditorInnerBtn = async () => {
        appEditorStore.commonBoardEditorModal.state = false;
        handleCloseModal(modalDepth);
        await appEditorStore.addBoard(id);
    }
    const iframeLoad = (event) => {
        if (parseInt(event.target.getBoundingClientRect().width) === 400 && appEditorStore.commonBoardEditorModal.ratio.Mobile) {
            event.target.style.height = appEditorStore.commonBoardEditorModal.ratio.Mobile.height + 'px';
        } else if (parseInt(event.target.getBoundingClientRect().width) === 775 && appEditorStore.commonBoardEditorModal.ratio.Desktop) {
            event.target.style.height = appEditorStore.commonBoardEditorModal.ratio.Desktop.height + 'px';
        }
    }
    return (
        <ModalBody id={"CommonBoardEditorModal"}>
            <EditCommonBoardWrap className={"modal-container"}>
                <div className={"btn-wrap"}>
                    <Button
                        type={""}
                        size={"m"}
                        text={"엮인 상품"}
                        className={"connected-prd"}
                        // onClickFunc={connectedPrdBtn}
                        onClickFunc={() => {
                            modalStore.openModal({
                                ...modalStore.MODAL_PAYLOAD.PRODUCT_CONNECT_BOARD
                            }, null);
                        }}
                    />
                    <div className="right">
                        <Button
                            type={"fill"}
                            size={"m"}
                            text={"수정하기"}
                            className={"modify"}
                            // onClickFunc={commonBoardEditorBtn}
                            onClickFunc={() => {
                                modalStore.openModal({
                                    ...modalStore.MODAL_PAYLOAD.COMMON_BOARD_EDITOR(),
                                    closeFunc: (closeCallback) => {
                                        if (appEditorStore.checkModifiedOnEditor('COMMON')) {
                                            confirmStore.openConfirm({
                                                confirmText: "확인",
                                                text: "창을 닫으면 작성 중인 내용을 잃습니다.\n닫으시겠습니까?",
                                                confirmFunc: async () => {
                                                    confirmStore.clear();
                                                    closeCallback();
                                                },
                                            });
                                        } else {
                                            closeCallback();
                                        }

                                    }
                                }, null);
                            }}
                        />
                        <Button
                            type={"fill"}
                            size={"m"}
                            text={"이 상세페이지에 삽입"}
                            className={"current-insert"}
                            onClickFunc={currentEditorInnerBtn}
                        />
                    </div>
                </div>


                <div className="preview-content-container">
                    <div className="nav-tab-wrap">
                        <div className={`nav ${currentTabView === 'pc' ? 'active' : ''}`}
                             onClick={pcView}
                        >
                            <span>PC</span>
                        </div>
                        <div className={`nav ${currentTabView === 'mo' ? 'active' : ''}`}
                             onClick={moView}
                        >
                            <span>Mobile</span>
                        </div>
                    </div>
                    <div className="preview-content-wrapper inner-iframe-container">
                        {
                            appEditorStore.commonBoardEditorModal.data &&
                            appEditorStore.commonBoardEditorModal.data.url &&
                            <iframe
                                ref={commonPreviewIframe}
                                className={`common-preview-iframe ${currentTabView}`}
                                id={`common-${appEditorStore.commonBoardEditorModal.data._id}`}
                                src={`${appEditorStore.commonBoardEditorModal.data.url}?time=${new Date().getTime()}`}
                                onLoad={iframeLoad}
                                // onLoad={(e) => {
                                //     resizeIframe(e.target)
                                // }}
                            ></iframe>
                        }
                    </div>
                </div>

                <div className={"modal-close"}>
                    <Button
                        size={"xl"}
                        text={"닫기"}
                        onClickFunc={clickClose}
                    />
                </div>
            </EditCommonBoardWrap>
        </ModalBody>
    );
};

const CommonBoardPreviewModalWrap = styled.div`
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;
const Dimmer = styled.div`
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
`;
const TableDisplay = styled.article`
    width: 800px;
    overflow: hidden;
    border-radius: 10px;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: 90vh;
`;
const EditCommonBoardWrap = styled.div`
    background-color: #fff;
    padding: 32px 32px 0;

    .btn-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;

        .connected-prd {
            border-color: #c8c8c8;
            color: #262626;
        }

        .modify {
            margin-right: 4px;
        }
    }

    .preview-content-container {
        background-color: #F5F5F5;

        .nav-tab-wrap {
            display: flex;
            align-items: center;
            height: 44px;

            > .nav {
                width: 50%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #B0B0B0;
                font-size: 14px;
                font-weight: 500;
                letter-spacing: -0.28px;
                background-color: transparent;
                cursor: pointer;

                &.active {
                    color: #fff;
                    background-color: #555;
                }
            }
        }

        .preview-content-wrapper {
            width: 100%;
            padding: 16px 0;
            display: flex;
            justify-content: center;
            max-height: 500px;
            overflow-y: auto;

            .common-preview-iframe {
                //transition: all ease-out .2s;
                overflow: hidden;

                body {
                    overflow: hidden;
                }

                &.pc {
                    width: 775px;
                    padding: 0 56px;
                }

                //

                &.mo {
                    width: 400px;
                }
            }
        }
    }

    .modal-close {
        padding: 16px 0;
        display: flex;
        justify-content: center;

        > button {
            color: #fff;
            background-color: #262626;
            width: 364px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
        }
    }
`;
const ModalHeader = styled.div`
    background: var(--Gray-1000_-262626, #262626);
    height: 48px;
    padding: 0px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h1 {
        color: var(--White_-FFFFFF, #fff);
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: -0.16px;
    }

    svg {
        cursor: pointer;
    }
`;
// const ModalBody = styled.div`
//     background-color: #fff;
//     padding: 32px 32px 0;
//
//     .btn-wrap {
//         display: flex;
//         align-items: center;
//         justify-content: space-between;
//         margin-bottom: 16px;
//
//         .connected-prd {
//             border-color: #c8c8c8;
//             color: #262626;
//         }
//
//         .modify {
//             margin-right: 4px;
//         }
//     }
//
//     .preview-content-container {
//         background-color: #F5F5F5;
//
//         .nav-tab-wrap {
//             display: flex;
//             align-items: center;
//             height: 44px;
//
//             > .nav {
//                 width: 50%;
//                 height: 100%;
//                 display: flex;
//                 align-items: center;
//                 justify-content: center;
//                 color: #B0B0B0;
//                 font-size: 14px;
//                 font-weight: 500;
//                 letter-spacing: -0.28px;
//                 background-color: transparent;
//                 cursor: pointer;
//
//                 &.active {
//                     color: #fff;
//                     background-color: #555;
//                 }
//             }
//         }
//
//         .preview-content-wrapper {
//             width: 100%;
//             padding: 36px;
//             display: flex;
//             justify-content: center;
//             max-height: 600px;
//             overflow-y: auto;
//
//             .common-preview-iframe {
//                 transition: all ease-out .2s;
//                 overflow: hidden;
//
//                 body {
//                     overflow: hidden;
//                 }
//
//                 &.pc {
//                     width: 100%;
//                 }
//
//                 &.mo {
//                     width: 365px;
//                 }
//             }
//         }
//     }
//
//     .modal-close {
//         padding: 16px 0;
//         display: flex;
//         justify-content: center;
//
//         > button {
//             color: #fff;
//             background-color: #262626;
//             width: 364px;
//             height: 40px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             border-radius: 4px;
//         }
//     }
// `;


export default CommonBoardPreviewModal;
